var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSubmittedData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 29.48V31.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 30.5H19.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.52H36.5395",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5195 13.52V15.52",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5195 6.5H9.51953C7.86268 6.5 6.51953 7.84315 6.51953 9.5V19.5C6.51953 21.1569 7.86268 22.5 9.51953 22.5H39.5195C41.1764 22.5 42.5195 21.1569 42.5195 19.5V9.5C42.5195 7.84315 41.1764 6.5 39.5195 6.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.52 38.5H9.52H9.5C7.84 38.48 6.5 37.14 6.5 35.5V25.5V25.48C6.5 23.82 7.84 22.48 9.5 22.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 36.16L38.18 29.06H38.16C38.94 28.26 40.2 28.26 40.98 29.04L43.88 31.94C44.66 32.72 44.66 33.98 43.88 34.76H43.86L36.76 41.84V41.82C36.38 42.18 35.86 42.4 35.34 42.4H30.42V37.48H30.418C30.418 36.94 30.618 36.44 30.998 36.06L31.1 36.16Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSubmittedData);
export default __webpack_public_path__ + "static/media/manageSubmittedData.ae934f94ec8c9c806ab55c6b900dacf6.svg";
export { ForwardRef as ReactComponent };